var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-index page-Index"},[_c('ContentTop'),_vm._m(0),_c('div',{staticClass:"profile-content"},[_c('TabTwoContent',{attrs:{"user":_vm.$root.user}})],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-top row"},[_c('div',{staticClass:"profile-title"},[_vm._v("個人資訊")])])
}]

export { render, staticRenderFns }